//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RepeatDialog',
  components: {},
  props: {
    repeatData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var checkWeek = function checkWeek(rule, value, callback) {
      if (_this.rules.repeat === 1 && value.length <= 0) {
        return callback(new Error(_this.$t('calendar.placeholder15')));
      } else {
        return callback();
      }
    };
    var checkMonth = function checkMonth(rule, value, callback) {
      if (_this.rules.repeat === 2 && value.length <= 0) {
        return callback(new Error(_this.$t('calendar.placeholder16')));
      } else {
        return callback();
      }
    };
    return {
      dialogVisible: false,
      rules: {
        repeat: 0,
        rate: 1,
        end_time: '',
        weekDays: [],
        monthDays: [],
        close: false,
        time: ''
      },
      rule: {
        rate: [{
          required: true,
          message: this.$t('calendar.placeholder17'),
          trigger: 'blur'
        }],
        weekDays: [{
          required: false,
          validator: checkWeek,
          trigger: 'change'
        }],
        monthDays: [{
          required: false,
          validator: checkMonth,
          trigger: 'change'
        }]
      },
      options: [{
        value: 0,
        label: this.$t('calendar.repeatbyday')
      }, {
        value: 1,
        label: this.$t('calendar.repeatweekly')
      }, {
        value: 2,
        label: this.$t('calendar.repeatmonthly')
      }, {
        value: 3,
        label: this.$t('calendar.repeatyear')
      }],
      week: [{
        value: '1',
        label: this.$t('hr.monday')
      }, {
        value: '2',
        label: this.$t('hr.tuesday')
      }, {
        value: '3',
        label: this.$t('hr.wednesday')
      }, {
        value: '4',
        label: this.$t('hr.thursday')
      }, {
        value: '5',
        label: this.$t('hr.friday')
      }, {
        value: '6',
        label: this.$t('hr.saturday')
      }, {
        value: '7',
        label: this.$t('hr.sunday')
      }],
      dayTitle: this.$t('access.day'),
      option: [{
        value: '',
        label: this.$t('calendar.neverend')
      }, {
        value: 1,
        label: this.$t('hr.placeholder4')
      }]
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    repeatData: {
      handler: function handler(nVal) {
        if (nVal.edit) {
          this.rules.repeat = nVal.data.period;
          this.rules.rate = nVal.data.rate;
          if (nVal.data.period === 1) {
            this.rules.weekDays = nVal.data.days;
          } else if (nVal.data.period === 2) {
            this.rules.monthDays = nVal.data.days;
          }
          this.handleRepeat(nVal.data.period);
          this.rules.time = nVal.data.end_time.indexOf('0000-00-00') > -1 ? '' : nVal.data.end_time;
        }
      },
      deep: true
    },
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.options = [{
        value: 0,
        label: this.$t('calendar.repeatbyday')
      }, {
        value: 1,
        label: this.$t('calendar.repeatweekly')
      }, {
        value: 2,
        label: this.$t('calendar.repeatmonthly')
      }, {
        value: 3,
        label: this.$t('calendar.repeatyear')
      }];
      this.week = [{
        value: 1,
        label: this.$t('hr.monday')
      }, {
        value: 2,
        label: this.$t('hr.tuesday')
      }, {
        value: 3,
        label: this.$t('hr.wednesday')
      }, {
        value: 4,
        label: this.$t('hr.thursday')
      }, {
        value: 5,
        label: this.$t('hr.friday')
      }, {
        value: 6,
        label: this.$t('hr.saturday')
      }, {
        value: 7,
        label: this.$t('hr.sunday')
      }];
      this.dayTitle = this.$t('access.day');
      this.option = [{
        value: '',
        label: this.$t('calendar.neverend')
      }, {
        value: 1,
        label: this.$t('hr.placeholder4')
      }];
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.rules.close = true;
      this.confirmData();
    },
    confirmData: function confirmData() {
      this.$emit('handleRepeatData', this.rules);
    },
    handleRepeat: function handleRepeat(e) {
      if (e === 0) {
        this.dayTitle = this.$t('access.day');
      } else if (e === 1) {
        this.dayTitle = this.$t('user.work.week');
      } else if (e === 2) {
        this.dayTitle = this.$t('user.work.month');
      } else if (e === 3) {
        this.dayTitle = this.$t('calendar.year');
      } else {
        this.dayTitle = this.$t('access.day');
      }
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this2.rules.time) {
            _this2.rules.end_time = _this2.$moment(_this2.rules.time).format('YYYY-MM-DD HH:mm:ss');
          } else {
            _this2.rules.end_time = '';
          }
          _this2.rules.close = false;
          _this2.dialogVisible = false;
          _this2.confirmData();
        }
      });
    }
  }
};